// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"41a438d4","593":"43e63eaa","715":"5954f6f7","830":"51917e98"}[chunkId] + ".chunk.css";
};